import axios from "axios";

export default axios.create({
    baseURL: "https://dijkstra-backend.ruihildt.xyz",
    responseType: "json"
});
